import { Injectable } from '@angular/core';

import { RestService } from './rest.service';

import { RecordType } from '../../common/types/utils';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  constructor(private readonly rest: RestService) {}

  getDocuments(recordType?: RecordType, recordId?: number): Promise<any> {
    if (recordType && recordId) {
      return this.rest.get(`${environment.apiUrl}/api/core/document?recordType=${recordType}&recordId=${recordId}`);
    } else {
      return this.rest.get(`${environment.apiUrl}/api/core/document`);
    }
  }

  uploadDocument(base64: string, recordType: RecordType, recordId: number, documentName: string): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/document`, { base64, recordType, recordId, documentName });
  }

  deleteDocument(recordType: RecordType, recordId: number, documentName: string): Promise<any> {
    const documentNameEncoded = encodeURIComponent(documentName);

    return this.rest.delete(
      `${environment.apiUrl}/api/core/document/${documentNameEncoded}?recordType=${recordType}&recordId=${recordId}
    `
    );
  }
}
